<!-- Title -->
<div style="text-align: center; margin-bottom: 20px;">
  <h2 style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f; margin: 0;">Resumen de Orden</h2>
</div>

<!-- Summary Card -->
<div style="background: white; border: 1px solid #e5e7eb; border-radius: 16px; overflow: hidden; margin-bottom: 20px;">
  <!-- Header -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 24px; border-bottom: 2px solid #bbf7d0;">
    <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
      <img src="assets/icons/zelle.png" alt="Zelle" style="width: 22px; height: 22px; object-fit: contain;">
      <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">Detalle de la transacción</span>
    </div>
  </div>

  <!-- Details -->
  <div style="padding: 0;">
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 24px; border-bottom: 1px solid #f3f4f6;">
      <span style="font-size: 0.82rem; color: #6b7280; font-weight: 500;">Tu envías</span>
      <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">{{ clpCurrency | currency:'':'' }} CLP</span>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 24px; border-bottom: 1px solid #f3f4f6;">
      <span style="font-size: 0.82rem; color: #6b7280; font-weight: 500;">Beneficiario recibe</span>
      <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">{{ zelleCurrency | currency:'':'' }} USD</span>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 24px; border-bottom: 1px solid #f3f4f6;">
      <span style="font-size: 0.82rem; color: #6b7280; font-weight: 500;">Beneficiario</span>
      <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">{{ beneficiario?.nombre }}</span>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 24px; border-bottom: 1px solid #f3f4f6;">
      <span style="font-size: 0.82rem; color: #6b7280; font-weight: 500;">Banco</span>
      <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">{{ beneficiario?.banco?.nombre }}</span>
    </div>
    <div *ngIf="beneficiario?.banco?.codigoBanco === 'BOFA'"
      style="display: flex; justify-content: space-between; align-items: center; padding: 12px 24px; border-bottom: 1px solid #f3f4f6;">
      <span style="font-size: 0.82rem; color: #6b7280; font-weight: 500;">Número cuenta</span>
      <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">{{ beneficiario?.numeroCuenta }}</span>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 24px; border-bottom: 1px solid #f3f4f6;">
      <span style="font-size: 0.82rem; color: #6b7280; font-weight: 500; flex-shrink: 0; margin-right: 12px;">Email/Teléfono</span>
      <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f; text-align: right; overflow-wrap: break-word; word-break: break-all;">{{ beneficiario?.identificador }}</span>
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 24px;">
      <span style="font-size: 0.82rem; color: #6b7280; font-weight: 500;">Tasa compra USD/CLP</span>
      <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">{{ usdt_clp_tax_zelle | number:'1.0-0' }}</span>
    </div>
  </div>
</div>

<!-- Buttons -->
<div style="display: flex; gap: 12px;">
  <button type="button" (click)="goToBack()"
    style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 14px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">arrow_back</mat-icon>
    Volver
  </button>
  <button type="button" (click)="confirmarEnvio()"
    style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">send</mat-icon>
    Enviar transacción
  </button>
</div>
